export default "__VITE_ASSET__fea5de14__"